/**
 *
 * Link file to make API calls to the new NODE based API for pdfs from the React environment
 *
 *
 */


export const NCL_PDFS = {
    PRIVACY: '/nclprivacystatement'
}

const PDF_PATH = '/api/node/pdf'

/**
 *
 *
 * Main function to display a pdf from anywhere within the application
 *
 *
 * @param pdfEndpoint e.g. /nclassessmentscreen OR /nclprivacystatement
 * @param login_jwt
 * @param queryParams e.g. &child_id=[enc_child_id] OR &child_id=[enc_child_id]&term_id=[term_id]
 */
export const constructNodePdfUrl = (pdfEndpoint, login_jwt, queryParams = null) =>
{
    const server = window.location.host ;

    const token = encodeURIComponent( login_jwt );

    const url = 'https://' + server + PDF_PATH + pdfEndpoint;

    const url2 = queryParams !== null ? url + '?' + queryParams + '&' : url + '?';

    return  url2 + 'token=' + token ;
}